import { combineReducers } from 'redux';
import printers, { NAME as printersKey } from './reducers/printers';
import passportScannerIntegrations, {
    NAME as passportScannerIntegrationsKey,
} from './ducks/passportScannerIntegrations';

import addresses, { NAME as addressesKey } from './ducks/addresses';
import accountNotes, { NAME as accountNotesKey } from './ducks/accountNotes';
import { NAME as customersKey, customersReducer } from './ducks/customers';
import creditLimits, { NAME as creditLimitsKey } from './ducks/creditLimits';
import exchangeRates, { NAME as exchangeRatesKey } from './ducks/exchangeRates';
import loyaltyMemberships, { NAME as loyaltyMembershipsKey } from './ducks/loyaltyMemberships';
import loyaltyPrograms, { NAME as loyaltyProgramsKey } from './ducks/loyaltyPrograms';
import loyaltyTiers, { NAME as loyaltyTiersKey } from './ducks/loyaltyTiers';
import identityDocuments, { NAME as identityDocumentsKey } from './ducks/identityDocuments';
import preauthorizations, { NAME as preauthorizationsKey } from './ducks/preauthorizations';
import profiles, { NAME as profilesKey } from './ducks/profiles';

import { NAME as accountingCategoriesKey, accountingCategoriesReducer } from './ducks/accountingCategories';
import { NAME as accountingConfigurationsKey, accountingConfigurationsReducer } from './ducks/accountingConfigurations';
import { NAME as ageCategoriesKey, ageCategoriesReducer } from './ducks/ageCategories';
import { NAME as applicationPermissionsKey, applicationPermissionsReducer } from './ducks/applicationPermissions';
import { NAME as applicationRegionsKey, applicationRegionsReducer } from './ducks/applicationRegions';
import { NAME as availabilitiesKey, availabilitiesReducer } from './ducks/availabilities';
import { NAME as availabilityAdjustmentsKey, availabilityAdjustmentsReducer } from './ducks/availabilityAdjustments';
import { NAME as availabilityBlocksKey, availabilityBlocksReducer } from './ducks/availabilityBlocks';
import { NAME as billsKey, billsReducer } from './ducks/bills';
import { NAME as bookingEngineKey, bookingEngineReducer } from './ducks/bookingEngine';
import { NAME as calendarEventsKey, calendarEventsReducer } from './ducks/calendarEvents';
import { NAME as cashiersKey, cashiersReducer } from './ducks/cashiers';
import { NAME as cashierAssignmentsKey, cashierAssignmentsReducer } from './ducks/cashierAssignments';
import { NAME as categoriesKey, categoriesReducer } from './ducks/categories';
import { NAME as chainsKey, chainsReducer } from './ducks/chains';
import { NAME as citiesKey, citiesReducer } from './ducks/cities';
import { NAME as companiesKey, companiesReducer } from './ducks/companies';
import { NAME as companionshipsKey, companionshipsReducer } from './ducks/companionships';
import { NAME as customerUsersKey, customerUsersReducer } from './ducks/customerUsers';
import { NAME as departmentsKey, departmentsReducer } from './ducks/departments';
import { NAME as enterpriseIntegrationsKey, enterpriseIntegrationsReducer } from './ducks/enterpriseIntegrations';
import { NAME as enterpriseProfilesKey, enterpriseProfilesReducer } from './ducks/enterpriseProfiles';
import {
    NAME as enterpriseProfileRolesAssignmentsKey,
    enterpriseProfileRolesAssignmentsReducer,
} from './ducks/enterpriseProfileRolesAssignments';
import { NAME as filesKey, filesReducer } from './ducks/files';
import { NAME as integrationDataKey, integrationDataReducer } from './ducks/integrationData';
import { NAME as legalEntityIdentifiersKey, legalEntityIdentifiersReducer } from './ducks/legalEntityIdentifiers';
import { NAME as messagesKey, messagesReducer } from './ducks/messages';
import { NAME as orderItemsKey, orderItemsReducer } from './ducks/orderItems';
import { NAME as paymentsKey, paymentsReducer } from './ducks/payments';
import { NAME as paymentCardsKey, paymentCardsReducer } from './ducks/paymentCards';
import { NAME as platformDocumentsKey, platformDocumentsReducer } from './ducks/platformDocuments';
import { NAME as productCategoriesKey, productCategoriesReducer } from './ducks/productCategories';
import { NAME as productsKey, productsReducer } from './ducks/products';
import { NAME as productServiceOrdersKey, productServiceOrdersReducer } from './ducks/productServiceOrders';
import { NAME as rateGroupsKey, rateGroupsReducer } from './ducks/rateGroups';
import { NAME as ratesKey, ratesReducer } from './ducks/rates';
import { NAME as rebateReasonsKey, rebateReasonsReducer } from './ducks/rebateReasons';
import {
    NAME as registrationCardConfigurationsKey,
    registrationCardConfigurationsReducer,
} from './ducks/registrationCardConfigurations';
import { NAME as reservationGroupsKey, reservationGroupsReducer } from './ducks/reservationGroups';
import { NAME as reservationsKey, reservationsReducer } from './ducks/reservations';
import { NAME as restrictionsKey, restrictionsReducer } from './ducks/restrictions';
import { NAME as resourceCategoriesKey, resourceCategoriesReducer } from './ducks/resourceCategories';
import { NAME as resourceFeaturesKey, resourceFeaturesReducer } from './ducks/resourceFeatures';
import {
    NAME as resourceCategoryAssignmentsKey,
    resourceCategoryAssignmentsReducer,
} from './ducks/resourceCategoryAssignments';
import {
    NAME as resourceFeatureAssignmentsKey,
    resourceFeatureAssignmentsReducer,
} from './ducks/resourceFeatureAssignments';
import { NAME as resourcesKey, resourcesReducer } from './ducks/resources';
import { NAME as resourceSlotsKey, resourceSlotsReducer } from './ducks/resourceSlots';
import { NAME as routingRuleAssignmentsKey, routingRuleAssignmentsReducer } from './ducks/routingRuleAssignments';
import { NAME as routingRulesKey, routingRulesReducer } from './ducks/routingRules';
import { NAME as scopesKey, scopesReducer } from './ducks/scopes';
import { NAME as servicesKey, servicesReducer } from './ducks/services';
import { NAME as serviceOrdersKey, serviceOrdersReducer } from './ducks/serviceOrders';
import { NAME as serviceOrderNotesKey, serviceOrderNotesReducer } from './ducks/serviceOrderNotes';
import { NAME as serviceSelectKey, serviceSelectReducer } from './ducks/serviceSelect';
import { NAME as sourcesKey, sourcesReducer } from './ducks/sources';
import { NAME as simpleUsersKey, simpleUsersReducer } from './ducks/simpleUsers';
import { NAME as spacesKey, spacesReducer } from './ducks/spaces';
import { NAME as subscriptionsKey, subscriptionsReducer } from './ducks/subscriptions';
import { NAME as tasksKey, tasksReducer } from './ducks/tasks';
import { NAME as threadsKey, threadsReducer } from './ducks/threads';
import { NAME as threadsMembershipKey, threadsMembershipReducer } from './ducks/threadsMembership';
import { NAME as travelAgenciesKey, travelAgenciesReducer } from './ducks/travelAgencies';
import { NAME as travelAgencyContractsKey, travelAgencyContractsReducer } from './ducks/travelAgencyContracts';
import { NAME as vouchersKey, vouchersReducer } from './ducks/vouchers';
import { NAME as enterprisesKey, enterprisesReducer } from './ducks/enterprises';
import { NAME as actionLogItemsKey, actionLogItemsReducer } from './ducks/actionLogItems';
import { NAME as enterpriseRelationshipsKey, enterpriseRelationshipsReducer } from './ducks/enterpriseRelationships';
import {
    NAME as reservationPurchaseOrderNumberKey,
    reservationPurchaseOrderNumberReducer,
} from './ducks/reservationPurchaseOrderNumber';

const accountUnawareReducers = {
    [chainsKey]: chainsReducer,
    [servicesKey]: servicesReducer,
    [scopesKey]: scopesReducer,
    [subscriptionsKey]: subscriptionsReducer,
    [enterprisesKey]: enterprisesReducer,
    [enterpriseRelationshipsKey]: enterpriseRelationshipsReducer,
};

const accountAwareReducers = {
    [accountingCategoriesKey]: accountingCategoriesReducer,
    [accountingConfigurationsKey]: accountingConfigurationsReducer,
    [accountNotesKey]: accountNotes,
    [ageCategoriesKey]: ageCategoriesReducer,
    [applicationPermissionsKey]: applicationPermissionsReducer,
    [applicationRegionsKey]: applicationRegionsReducer,
    [availabilitiesKey]: availabilitiesReducer,
    [availabilityAdjustmentsKey]: availabilityAdjustmentsReducer,
    [availabilityBlocksKey]: availabilityBlocksReducer,
    [addressesKey]: addresses,
    [billsKey]: billsReducer,
    [bookingEngineKey]: bookingEngineReducer,
    [calendarEventsKey]: calendarEventsReducer,
    [cashiersKey]: cashiersReducer,
    [cashierAssignmentsKey]: cashierAssignmentsReducer,
    [categoriesKey]: categoriesReducer,
    [citiesKey]: citiesReducer,
    [companiesKey]: companiesReducer,
    [companionshipsKey]: companionshipsReducer,
    [customerUsersKey]: customerUsersReducer,
    [customersKey]: customersReducer,
    [creditLimitsKey]: creditLimits,
    [departmentsKey]: departmentsReducer,
    [enterpriseIntegrationsKey]: enterpriseIntegrationsReducer,
    [enterpriseProfileRolesAssignmentsKey]: enterpriseProfileRolesAssignmentsReducer,
    [enterpriseProfilesKey]: enterpriseProfilesReducer,
    [exchangeRatesKey]: exchangeRates,
    [filesKey]: filesReducer,
    [identityDocumentsKey]: identityDocuments,
    [integrationDataKey]: integrationDataReducer,
    [legalEntityIdentifiersKey]: legalEntityIdentifiersReducer,
    [loyaltyMembershipsKey]: loyaltyMemberships,
    [loyaltyProgramsKey]: loyaltyPrograms,
    [loyaltyTiersKey]: loyaltyTiers,
    [messagesKey]: messagesReducer,
    [orderItemsKey]: orderItemsReducer,
    [passportScannerIntegrationsKey]: passportScannerIntegrations,
    [paymentCardsKey]: paymentCardsReducer,
    [paymentsKey]: paymentsReducer,
    [platformDocumentsKey]: platformDocumentsReducer,
    [preauthorizationsKey]: preauthorizations,
    [printersKey]: printers,
    [productCategoriesKey]: productCategoriesReducer,
    [productsKey]: productsReducer,
    [productServiceOrdersKey]: productServiceOrdersReducer,
    [profilesKey]: profiles,
    [rateGroupsKey]: rateGroupsReducer,
    [ratesKey]: ratesReducer,
    [rebateReasonsKey]: rebateReasonsReducer,
    [registrationCardConfigurationsKey]: registrationCardConfigurationsReducer,
    [reservationGroupsKey]: reservationGroupsReducer,
    [reservationPurchaseOrderNumberKey]: reservationPurchaseOrderNumberReducer,
    [reservationsKey]: reservationsReducer,
    [restrictionsKey]: restrictionsReducer,
    [resourceCategoriesKey]: resourceCategoriesReducer,
    [resourceCategoryAssignmentsKey]: resourceCategoryAssignmentsReducer,
    [resourceFeatureAssignmentsKey]: resourceFeatureAssignmentsReducer,
    [resourceFeaturesKey]: resourceFeaturesReducer,
    [resourcesKey]: resourcesReducer,
    [resourceSlotsKey]: resourceSlotsReducer,
    [routingRuleAssignmentsKey]: routingRuleAssignmentsReducer,
    [routingRulesKey]: routingRulesReducer,
    [spacesKey]: spacesReducer,
    [serviceOrdersKey]: serviceOrdersReducer,
    [serviceOrderNotesKey]: serviceOrderNotesReducer,
    [serviceSelectKey]: serviceSelectReducer,
    [simpleUsersKey]: simpleUsersReducer,
    [sourcesKey]: sourcesReducer,
    [tasksKey]: tasksReducer,
    [threadsKey]: threadsReducer,
    [threadsMembershipKey]: threadsMembershipReducer,
    [travelAgenciesKey]: travelAgenciesReducer,
    [travelAgencyContractsKey]: travelAgencyContractsReducer,
    [vouchersKey]: vouchersReducer,
    [actionLogItemsKey]: actionLogItemsReducer,
};

export default combineReducers({
    ...accountUnawareReducers,
    ...accountAwareReducers,
});
